export function getTabNr() {
    let tabNr = 0
    if (window.location.search) {
        const searchParams = new URLSearchParams(window.location.search);
        const tab = searchParams.get("tab");
        if (tab) {
            tabNr = parseInt(tab, 10);
        }
    }
    return tabNr
}

export function setTabNr(tabNr: number) {
    if ('URLSearchParams' in window) {
        const url = new URL(window.location.href);
        url.searchParams.set("tab", "" + tabNr);
        history.pushState(null, '', url);
    }
}